/* eslint-disable import/prefer-default-export */

export function hideSplashScreen() {
  const rootElement = document.getElementById('root');
  rootElement.classList.add('loaded');
}
